<input class="form-check-input" type="checkbox" role="switch" id="obligatoire" [(ngModel)]="field" [disabled]="_disabled" />
